<template>
	<page>
		<module>
			<div class="group">
				<c-title>基础功能配置</c-title>
				<ul class="flex-wrap">
					<li v-for="(item, i) in videoList" :key="i" :title="item.name" @click="playHandle(item)">
						<div class="cover">
							<img :src="item.cover" alt="">
							<div class="mask flex-center"><i class="tf">&#xe611;</i></div>
							<div class="info">
								<!-- <span>{{item.tags}}</span> -->
								<span>{{item.duration}}</span>
							</div>
						</div>
						<h5 class="ellipsis-2">{{item.name}}</h5>
					</li>
				</ul>
			</div>

			<c-dialog ref="player" :button="false" width="1155" height="740" enable-flex :resize-button="['max']" @close="video = null">
				<div v-if="video" class="player flex-grow flex-column">
					<video ref="video" class="flex-grow" :src="video.path" controls></video>
					<!-- <div ref="timelineScroll" class="timeline">
						<ul class="flex">
							<li v-for="(item, i) in video.timeline" :key="i" ref="timeline" class="flex-column flex-center-start" :class="{'z-crt': i == currentTimelineIndex}" @click="timelineHandle(i)">
								<p><i class="tf">&#xe706;</i>{{item.time}}</p>
								<h5>{{item.name}}</h5>
							</li>
						</ul>
					</div> -->
				</div>
			</c-dialog>
		</module>
	</page>
</template>

<script>
	export default {
		data() {
			return {
				// videoList: [{
				// 	path: 'https://cdn.ycmes.cn/static/ycmes/video/基础数据创建-新手必看_0923.mp4',
				// 	cover: 'https://cdn.ycmes.cn/static/ycmes/video/基础数据创建-新手必看.jpg',
				// 	name: '基础数据创建-新手必看',
				// 	tags: '工序 | 工艺路线 | 工单',
				// 	duration: '16分15秒',
				// 	timeline: [{
				// 		time: '00:33',
				// 		name: '工作台展示（电脑端）'
				// 	}, {
				// 		time: '01:37',
				// 		name: '基础数据的创建'
				// 	}, {
				// 		time: '01:46',
				// 		name: '工序的创建'
				// 	}, {
				// 		time: '04:23',
				// 		name: '工艺路线的创建'
				// 	}, {
				// 		time: '05:25',
				// 		name: '单位的创建'
				// 	}, {
				// 		time: '05:37',
				// 		name: '产品的创建'
				// 	}, {
				// 		time: '06:39',
				// 		name: '物料清单的配置'
				// 	}, {
				// 		time: '07:07',
				// 		name: '绩效工资的配置'
				// 	}, {
				// 		time: '07:47',
				// 		name: '生产管理展示'
				// 	}, {
				// 		time: '07:55',
				// 		name: '工单的创建'
				// 	}, {
				// 		time: '10:38',
				// 		name: '电脑端如何报工'
				// 	}, {
				// 		time: '12:27',
				// 		name: '移动端如何报工'
				// 	}, {
				// 		time: '14:19',
				// 		name: '报告记录的审批'
				// 	}, {
				// 		time: '15:00',
				// 		name: '报工工作台 （电脑端）'
				// 	}, {
				// 		time: '15:15',
				// 		name: '排产日历'
				// 	}, {
				// 		time: '15:31',
				// 		name: '工单工作台展示（移动端）'
				// 	}]
				// }],
				videoList: [{
					path: 'https://cdn.ycmes.cn/static/ycmes/video/视频1.mp4',
					cover: 'https://cdn.ycmes.cn/static/ycmes/video/封面01-封面.jpg',
					name: '蜂鸟工单总体功能介绍',
					tags: '',
					duration: '09分23秒'
				}, {
					path: 'https://cdn.ycmes.cn/static/ycmes/video/视频2.mp4',
					cover: 'https://cdn.ycmes.cn/static/ycmes/video/封面02-封面.jpg',
					name: '使用教程：如何创建工单，手机扫码报工',
					tags: '',
					duration: '03分05秒'
				}, {
					path: 'https://cdn.ycmes.cn/static/ycmes/video/视频3.mp4',
					cover: 'https://cdn.ycmes.cn/static/ycmes/video/封面03-封面.jpg',
					name: '使用教程：如何创建销售订单，转生产工单，自动入库，订单发货',
					tags: '',
					duration: '03分01秒'
				}, {
					path: 'https://cdn.ycmes.cn/static/ycmes/video/视频4.mp4',
					cover: 'https://cdn.ycmes.cn/static/ycmes/video/封面04-封面.jpg',
					name: '使用教程：创建采购订单，收货、退货',
					tags: '',
					duration: '02分00秒'
				}, {
					path: 'https://cdn.ycmes.cn/static/ycmes/video/视频5.mp4',
					cover: 'https://cdn.ycmes.cn/static/ycmes/video/封面05-封面.jpg',
					name: '使用教程：配置物料清单，手动领料、自动领料',
					tags: '',
					duration: '02分52秒'
				}, {
					path: 'https://cdn.ycmes.cn/static/ycmes/video/视频6.mp4',
					cover: 'https://cdn.ycmes.cn/static/ycmes/video/封面06-封面.jpg',
					name: '使用教程：配置绩效工资，报工自动计算',
					tags: '',
					duration: '03分25秒'
				}],

				video: null,
				time: 0
			}
		},

		computed: {
			// secTimeline() {
			// 	return this.video ? this.video.timeline.map(item => {
			// 		let time = item.time.split(':');
			// 		return parseInt(time[0]) * 60 + parseInt(time[1]);
			// 	}) : [];
			// },

			// currentTimelineIndex() {
			// 	return this.secTimeline.findIndex((item, index) => {
			// 		return this.time >= item && (!this.secTimeline[index + 1] || this.time < this.secTimeline[index + 1]);
			// 	});
			// }
		},

		watch: {
			// currentTimelineIndex(val) {
			// 	if (val == -1) return;
			// 	this.$refs.timelineScroll.scrollLeft = this.$refs.timeline[val].offsetLeft - (this.$refs.timelineScroll.clientWidth / 2) + (this.$refs.timeline[val].clientWidth / 2);
			// }
		},
		
		methods: {
			playHandle(item) {
				this.video = item;
				this.time = 0;
				this.$nextTick(() => {
					this.$refs.player.open({
						title: item.name
					});
					this.$refs.video.play();
					// this.$refs.video.addEventListener('timeupdate', () => {
					// 	this.time = parseInt(this.$refs.video.currentTime);
					// });
				});
			},

			timelineHandle(index) {
				this.$refs.video.currentTime = this.time = this.secTimeline[index];
				this.$refs.video.play();
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.group {
		padding: 30px 36px;

		ul {
			gap: 24px;
			margin-top: 10px;

			li {
				box-sizing: border-box;
				width: 340px;
				height: 250px;
				border-radius: 6px;
				padding: 10px 10px 0;
				background: #F6F6F6;
				cursor: pointer;
				transition: background .3s ease;

				&:hover {
					background: #EBFAF7;
				}

				.cover {
					position: relative;
					height: 180px;
					border-radius: 6px;
					overflow: hidden;

					.mask {
						content: '';
						position: absolute;
						inset: 0;
						font-size: 48px;
						color: #fff;
						background: rgba(0,0,0,.5);
					}

					.info {
						position: absolute;
						right: 0;
						top: 0;
						width: 66px;
						border-radius: 0 6px 0 6px;
						line-height: 24px;
						font-size: 12px;
						text-align: center;
						color: #fff;
						background: rgba(0,0,0,.6);
					}
				}

				h5 {
					padding: 8px 0;
					line-height: 20px;
					font-size: 14px;
					font-weight: 500;
				}
			}
		}
	}

	.player {
		padding: 24px;
		
		video {
			width: 100%;
			background: #000;
		}

		.timeline {
			position: relative;
			margin-top: 10px;
			overflow-x: auto;
			overflow-y: hidden;

			ul {
				gap: 6px;
				float: left;
				padding-bottom: 10px;

				li {
					gap: 8px;
					box-sizing: border-box;
					min-width: 130px;
					height: 54px;
					border-radius: 4px;
					padding: 0 8px;
					white-space: nowrap;
					background: #F5F5F5;
					cursor: pointer;

					&:hover, &.z-crt {
						background: #EAF9F6;
					}
					
					&.z-crt {
						color: #00B38A;
					}

					p {
						gap: 5px;
						font-size: 12px;
						color: #666;

						^[-1].z-crt ^[-1..-1] {
							color: #00B38A;
						}
					}

					h5 {
						font-size: 13px;
						font-weight: normal;
					}
				}
			}
		}
	}
</style>
